
import axios from '../wmsAxios'

// 保存
export const save = (data) => {
    return axios({
        url: '/tblSnMaster/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblSnMaster/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblSnMaster/findPage',
        method: 'post',
      data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblSnMaster.js